module.exports = __webpack_public_path__ + "static/media/event.44e557c9.jpg";